// extracted by mini-css-extract-plugin
export default {"link":"sortable_header___link___d4f8bfbb"};